import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, PopoverController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ModalData, ModalOption } from '../../type/modal';

@Component({
    selector: 'app-custom-select-popover',
    standalone: true,
    imports: [CommonModule, IonicModule, TranslateModule],
    templateUrl: './custom-select-popover.component.html',
    styleUrl: './custom-select-popover.component.scss',
})
export class CustomSelectPopoverComponent implements OnInit {
  @Input() options: { value: string; label: string }[] = [];
  @Input() defaultValue: { value: string; label: string } | null = null;

  searchText = '';
  filteredOptions: { value: string; label: string }[] = [];

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {
    this.filteredOptions = [...this.options];
  }

  onSearch(event: any) {
    const search = (event.target.value || '').toLowerCase();
    this.filteredOptions = this.options.filter(option =>
      option.label.toLowerCase().includes(search)
    );
  }

  selectOption(option: { value: string; label: string }) {
    this.popoverCtrl.dismiss(option.value);
  }
}
